import React from "react";
import { useFormikContext } from "formik";
import baseStyles from "../../style.module.scss";
import ReviewHeader from "../common/ReviewHeader";

const ConditionalAddendums = ({
  cbdRequired,
  vapeRequired,
  isOpen,
  onToggle,
  onEdit,
}) => {
  const { values } = useFormikContext();

  if (!cbdRequired && !vapeRequired) return null;

  const cbdFileName = values.cbd_addendum_file?.name || values.cbd_addendum_file?.file || "-";
  const productTypes =
    (values.vape_attestation_product_types || [])
      .map((p) => p?.name)
      .filter(Boolean)
      .join(", ") || "-";

  const Row = ({ label, value }) => (
    <div className={baseStyles.detailItem}>
      <div className={baseStyles.detailLabel}>{label}</div>
      <div className={baseStyles.detailValue}>{value || "-"}</div>
    </div>
  );

  return (
    <div className={baseStyles.reviewSectionContainer}>
      <ReviewHeader
        title="Kurv Addendums"
        isOpen={isOpen}
        onToggle={onToggle}
        onEdit={onEdit}
      />

      {isOpen && (
        <div className={baseStyles.reviewContent}>
          {cbdRequired && (
            <div className={baseStyles.section}>
              <div className={baseStyles.detailsGrid}>
                <Row label="CBD Product Pricing" value={cbdFileName} />
              </div>
            </div>
          )}

          {vapeRequired && (
            <div className={baseStyles.section}>
              <div className={baseStyles.detailsGrid}>
                <Row
                  label="Source of marketing"
                  value={values.vape_attestation_what_is_your_source_of_marketing}
                />
                <Row
                  label="Audience"
                  value={values.vape_attestation_what_audience_is_the_product_marketed_to}
                />
                <Row label="Top product 1" value={values.vape_attestation_product_1} />
                <Row label="Top product 2" value={values.vape_attestation_product_2} />
                <Row label="Top product 3" value={values.vape_attestation_product_3} />
                <Row label="Top product 4" value={values.vape_attestation_product_4} />
                <Row label="Top product 5" value={values.vape_attestation_product_5} />
                <Row label="Manufacturer" value={values.where_are_the_products_manufactured} />
                <Row label="Product types" value={productTypes} />
                <Row
                  label="Age verification method"
                  value={
                    values.vape_attestation_method_of_age_verification === "Other"
                      ? values.vape_attestation_other_method_of_age_verification
                      : values.vape_attestation_method_of_age_verification
                  }
                />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ConditionalAddendums;
